module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Lenzburg-3fd38f4052e6032449991c4e5f97ee4c.svg";